import { CartHelper } from "./CartHelper.js"
import { I18N } from "./I18N.js"
import { ProductHelper } from "./ProductHelper.js"
import { Toast } from "./Toast.js"

export class ProductConfigurator {
	_target
	_itemVO
	_products
	_store
	_taxRate
	_onAddToCartHandlers = []
	_hideTax = true
	_hideNet = true
	_selectVariantToast
	_selectOptionToasts = []

	constructor(target, products, product, store, taxRate) {
		this._target = document.getElementById(target)
		this._itemVO = { product: product, qty: 1, remarks: '', extraCategories: [] }
		const defaultVariant = ProductHelper.getDefaultVariant(this._itemVO.product)
		if (defaultVariant) {
			this._itemVO.variant = defaultVariant
		}
		this._products = products
		this._store = store
		this._taxRate = taxRate
		this._extraOptionGroups = ProductHelper.getExtraOptionGroups(this._products, this._itemVO.product.productId)
	}

	setVisible = visible => {
		if (visible) {
			this._target.innerHTML = `
				<div class="modalCanvas">
					<div class="modalShader"></div>
					<div class="card modal">
						<button id="prodConfigCloseBtn" class="closeBtn" i18n>Close </button>
						<h1>${this._itemVO.product.translatedName || this._itemVO.product.productName}</h1>
						${this._itemVO.product.shortDescriptionHtml ? `<div class="productShortDescription">${this._itemVO.product.shortDescriptionHtml}</div>` : ''}
						${this._itemVO.product.descriptionHtml ? `<div class="productFullDescription">${this._itemVO.product.descriptionHtml}</div>` : ''}
						${(this._itemVO.product.allergens && this._itemVO.product.allergens.length) || (this._itemVO.product.additives && this._itemVO.product.additives.length) ? `<div class="btnGroup">
							${this._itemVO.product.allergens && this._itemVO.product.allergens.length ? `<details><summary>${I18N.translate('Allergens')}</summary><ul>${this._itemVO.product.allergens.map(i => `<li>${i.substring(2)}</li>`).join('')}</ul></details>` : ''}
							${this._itemVO.product.additives && this._itemVO.product.additives.length ? `<details><summary>${I18N.translate('Additives')}</summary><ul>${this._itemVO.product.additives.map(i => `<li>${i.substring(2)}</li>`).join('')}</ul></details>` : ''}
						</div>` : ''}
						<h2 i18n>Base Price</h2>
						<div id="productDisplayTable"></div>
						<h2>Extras</h2>
						<div id="productExtrasDisplayTable"></div>
						<h2 i18n>Remarks</h2>
						<textarea id="prodConfRemarks" rows="4" cols="50">${this._itemVO.remarks}</textarea>
						<h2 i18n>Quantity</h2>
						<input type="number" id="prodConfigQtyInput" value="${this._itemVO.qty}">
						<h2 i18n>Total Price</h2>
						<table class="priceTable">
							<thead>
								${this._hideNet ? '' : `<td class="priceColumn" i18n>Net</td>`}
								${this._hideTax ? '' : `<td class="priceColumn" i18n>Tax</td>`}
								${this._hideNet && this._hideTax ? '' : `<td class="priceColumn" i18n>Gross</td>`}
							</thead>
							<tbody>
								<tr class="sumRow">
									${this._hideNet ? '' : `<td id="prodConfNetPrice" class="priceColumn"></td>`}
									${this._hideTax ? '' : `<td id="prodConfTax" class="priceColumn"></td>`}
									<td id="prodConfGrossPrice" class="priceColumn"></td>
								</tr>
							</tbody>
						</table>
						<div class="btnGroup">
							<button id="prodConfigAddToCartBtn" class="primary" i18n>Add to Cart </button>
							<button id="prodConfigCancelBtn" i18n>Close</button>
						</div>
					</div>
				</div>
			`
			// Remarks textarea
			const remarksTextarea = document.getElementById('prodConfRemarks')
			remarksTextarea.addEventListener('blur', () => {
				this._itemVO.remarks = remarksTextarea.value
			})
			// Click add to cart button
			document.getElementById('prodConfigAddToCartBtn').addEventListener('click', () => {
				this.addToCart()
				this.close()
			})
			this._target.querySelector('#prodConfigCancelBtn').addEventListener('click', () => this.close())
			this._target.querySelector('#prodConfigCloseBtn').addEventListener('click', () => this.close())
			this._target.querySelector('.modalShader').addEventListener('click', () => this.close())
			// Display pruduct with extra options
			this._displayProduct()
			this._displayExtras()
			this._hideInappropriateExtras()
			this._updatePrice()
			I18N.translateElement(this._target)
		}
		else {
			this._target.innerHTML = ''
		}
	}

	_hideInappropriateExtras = () => {
		this._target.querySelectorAll('.extraForVariant').forEach(tr => {
			tr.querySelectorAll('input[type=checkbox]:checked').forEach(cb => {
				cb.checked = false
				// Remove invalid options from item
				const extraOptionId = tr.getAttribute('extraOptionId')
				if (this._itemVO.extraCategories) {
					this._itemVO.extraCategories.forEach(ec => ec.extraOptions ? ec.extraOptions = ec.extraOptions.filter(eo => eo.extraOptionId !== extraOptionId) : null)
				}
			})
			tr.setAttribute('hidden', '')
		})
		// Remove empty categories
		if (this._itemVO.extraCategories) {
			this._itemVO.extraCategories = this._itemVO.extraCategories.filter(ec => ec.extraOptions && ec.extraOptions.length)
		}
		const allowVariant = this._itemVO.variant ? `.extraForVariant_${this._itemVO.variant.variantId}` : '.never'
		this._target.querySelectorAll('.extraForVariant' + allowVariant).forEach(tr => tr.removeAttribute('hidden'))
	}

	addToCart = () => this._onAddToCartHandlers.forEach(handler => handler(this._itemVO, this._store, this._taxRate))

	addOnAddToCartHandlers = (...onAddToCartHandlers) => this._onAddToCartHandlers.push(...onAddToCartHandlers)

	close = () => this._target.innerHTML = ''

	_displayProduct = () => {
		const eventMap = new Map()

		const getVariantPriceRows = variants => variants.map(v => {
			const rbId = `variant_${v.variantId}`
			eventMap.set(rbId, v)
			return `<tr>
					<td><input type="radio" id="${rbId}" name="variant" ${v.default ? 'checked' : ''}></td>
					<td><label for="${rbId}">${v.name}</label></td>
					${this._hideNet ? '' : `<td class="priceColumn">${CartHelper.formatPrice(v.net)}</td>`}
					${this._hideTax ? '' : `<td class="priceColumn">${CartHelper.formatPrice(v.tax)}</td>`}
					<td class="priceColumn">${CartHelper.formatPrice(v.net + v.tax)}</td>
				</tr>`
		}).join('')

		const getPriceTable = () => {
			if (this._itemVO.product.variants && this._itemVO.product.variants.length) {
				return `<h3 i18n>Variant</h3>
					<table class="priceTable">
						<thead>
							<td></td>
							<td>${this._itemVO.product.variants[0].attributeName}</td>
							${this._hideNet ? '' : `<td class="priceColumn" i18n>Net</td>`}
							${this._hideTax ? '' : `<td class="priceColumn" i18n>Tax</td>`}
							<td class="priceColumn" i18n>Gross</td>
						</thead>
						<tbody>
							${getVariantPriceRows(this._itemVO.product.variants)}
						</tbody>
					</table>`
			}
			else {
				return `<table class="priceTable">
						<thead>
							${this._hideNet ? '' : `<td class="priceColumn" i18n>Net</td>`}
							${this._hideTax ? '' : `<td class="priceColumn" i18n>Tax</td>`}
							<td class="priceColumn" i18n>${this._hideTax && this._hideTax ? '' : `Gross`}</td>
						</thead>
						<tbody>
							<tr>
								${this._hideNet ? '' : `<td class="priceColumn">${CartHelper.formatPrice(this._itemVO.product.net)}</td>`}
								${this._hideTax ? '' : `<td class="priceColumn">${CartHelper.formatPrice(this._itemVO.product.tax)}</td>`}
								<td class="priceColumn">${CartHelper.formatPrice(this._itemVO.product.net + this._itemVO.product.tax)}</td>
							</tr>
						</tbody>
					</table>`
			}
		}

		this._target.querySelector('#productDisplayTable').innerHTML = getPriceTable()

		this._target.querySelector('#prodConfigQtyInput').addEventListener('change', ev => {
			this._itemVO.qty = Number(ev.target.value)
			this._updatePrice()
		})
		eventMap.forEach((variant, rbId) => {
			this._target.querySelector('#' + rbId).addEventListener('click', ev => {
				console.debug('Variant selected: ', variant)
				this._itemVO.variant = variant
				this._hideInappropriateExtras()
				this._updatePrice()
			})
		})
	}

	_displayExtras = () => {
		const eventKeyMap = new Map()

		const displayExtras = () => {
			// Render extra categories
			return this._extraOptionGroups.map(extraCategoryEntry => {
				const forVariantClasses = extraCategoryEntry.variationId ? `extraForVariant extraForVariant_${extraCategoryEntry.variationId}` : ''
				return `<tr class="${forVariantClasses}">
						<td colspan="5"><h3><label ${extraCategoryEntry.singleSelect ? 'required' : ''}>${I18N.format('{0}', extraCategoryEntry.extraCategory.extraCategoryName).replaceAll('_', ' ')}</label></h3></td>
					</tr>
					${extraCategoryEntry.extras.map(extraOption => {
					const extraOptionId = extraOption.extraOptionId + (extraCategoryEntry.variationId ? '_' + extraCategoryEntry.variationId : '')
					eventKeyMap.set(extraOptionId, { extraCategory: extraCategoryEntry.extraCategory, extraOption: extraOption, singleSelect: extraCategoryEntry.singleSelect })
					return `<tr class="${forVariantClasses}" extraOptionId="${extraOption.extraOptionId}">
								<td>${extraCategoryEntry.singleSelect
							? `<input type="radio" name="${extraCategoryEntry.extraCategory.extraCategoryId}" id="ProdConfigOption${extraOptionId}Check">`
							: `<input type="checkbox" id="ProdConfigOption${extraOptionId}Check">`}</td>
								<td><label for="ProdConfigOption${extraOptionId}Check" >${extraOption.extraOptionName}</label></td>
								${this._hideNet ? '' : `<td class="priceColumn">${extraOption.net > 0 ? CartHelper.formatPrice(extraOption.net) : ''}</td>`}
								${this._hideTax ? '' : `<td class="priceColumn">${extraOption.net > 0 ? CartHelper.formatPrice(extraOption.tax) : ''}</td>`}
								<td class="priceColumn">${extraOption.net > 0 ? CartHelper.formatPrice(extraOption.net + extraOption.tax) : ''}</td>
							</tr>`
				}).join('')}`
			}).join('')
		}

		document.getElementById('productExtrasDisplayTable').innerHTML = `<table class="priceTable">
				<thead>
					<td></td>
					<td></td>
					${this._hideNet ? '' : `<td class="priceColumn" i18n>Net</td>`}
					${this._hideTax ? '' : `<td class="priceColumn" i18n>Tax</td>`}
					${this._hideNet && this._hideTax ? '' : `<td class="priceColumn" i18n>Gross</td>`}
				</thead>
				<tbody>
					${displayExtras()}
				</tbody>
			</table>`

		// Select extra events
		eventKeyMap.forEach((selection, key) => {
			document.getElementById(`ProdConfigOption${key}Check`).addEventListener('click', ev => {
				if (ev.target.checked) {
					console.debug('Adding option to item: ', selection, this._itemVO)
					let productExtraCategories = this._itemVO.extraCategories
					if (!productExtraCategories) {
						productExtraCategories = []
						this._itemVO.extraCategories = productExtraCategories
					}
					let productExtraCategory = productExtraCategories.find(ec => ec.extraCategoryName === selection.extraCategory.extraCategoryName)
					if (!productExtraCategory) {
						productExtraCategory = {
							extraCategoryName: selection.extraCategory.extraCategoryName,
							extraOptions: []
						}
						productExtraCategories.push(productExtraCategory)
					}
					else if (selection.singleSelect) {
						// Remove other options of existing extra category
						productExtraCategory.extraOptions = []
					}
					let productExtraOption = productExtraCategory.extraOptions.find(o => o.extraOptionId === selection.extraOption.extraOptionId)
					if (!productExtraOption) {
						const extraOptionClone = JSON.parse(JSON.stringify(selection.extraOption))
						productExtraCategory.extraOptions.push(extraOptionClone)
					}
				}
				else {
					console.log('Removing option from product: ', selection, this._itemVO)
					let productExtraCategories = this._itemVO.extraCategories
					let productExtraCategory = productExtraCategories.find(ec => ec.extraCategoryName === selection.extraCategory.extraCategoryName)
					productExtraCategory.extraOptions = productExtraCategory.extraOptions.filter(o => o.extraOptionId !== selection.extraOption.extraOptionId)
				}
				this._updatePrice()
				console.debug('Updated product: ', this._itemVO)
			})
		})
	}

	variantSelected = () => !this.noVariantSelected()

	noVariantSelected = () => ProductHelper.requiresVariantSelection(this._itemVO.product) && !this._itemVO.variant

	getMissingRequiredExtraCategories = () => this._extraOptionGroups.filter(extraCategoryEntry => {
		const isSingleSelect = extraCategoryEntry.singleSelect
		const optionSelected = !isSingleSelect || (
			this._itemVO.extraCategories
			&& this._itemVO.extraCategories.length
			&& this._itemVO.extraCategories.some(
				extraCategory => extraCategory.extraCategoryName === extraCategoryEntry.extraCategory.extraCategoryName && extraCategory.extraOptions.length
			)
		)
		const requiredOptionMissing = !optionSelected
		if (requiredOptionMissing) {
			console.log("Please select option for ", extraCategoryEntry.extraCategory.extraCategoryName)
		}
		return requiredOptionMissing
	}).map(extraCategoryEntry => extraCategoryEntry.extraCategory)

	_updatePrice = () => {
		const prodConfigAddToCartBtn = document.getElementById('prodConfigAddToCartBtn')
		// Check for selected option
		if (this.noVariantSelected()) {
			this._selectVariantToast = new Toast('toaster', I18N.translate('Please select a variant'), Toast.INFO, 7)
			prodConfigAddToCartBtn.setAttribute('disabled', '')
			return
		}
		else if (this._selectVariantToast) {
			this._selectVariantToast.dismiss()
		}
		// check for required options
		this._selectOptionToasts.forEach(t => t.dismiss())
		this._selectOptionToasts = []
		const missingExtraCategories = this.getMissingRequiredExtraCategories()
		missingExtraCategories.forEach(missingExtraCategory => {
			this._selectOptionToasts.push(new Toast('toaster', I18N.translateAndFormat('Set the required option for {0}', missingExtraCategory.extraCategoryName), Toast.INFO, 7))
			prodConfigAddToCartBtn.setAttribute('disabled', '')
		})
		if (missingExtraCategories.length) {
			return
		}

		prodConfigAddToCartBtn.removeAttribute('disabled')
		const net = CartHelper.calculateItemNet(this._itemVO)
		if (!this._hideNet) {
			document.getElementById('prodConfNetPrice').innerHTML = CartHelper.formatPrice(net)
		}
		const tax = CartHelper.calculateItemTax(this._itemVO)
		if (!this._hideNet) {
			document.getElementById('prodConfTax').innerHTML = CartHelper.formatPrice(tax)
		}
		const gross = net + tax
		document.getElementById('prodConfGrossPrice').innerHTML = CartHelper.formatPrice(gross)
	}

}